import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import { sensorTypeReducer } from './sensor-data/sensor-reducer';
import { SENSOR_FEATURE_KEY } from './sensor-data/sensor-selector';
import { SensorEffects } from './sensor-data/sensor.effects';
import { UserStoreModule } from './user-data/user-store.module';

@NgModule({
  declarations: [],
  imports: [
    UserStoreModule,
    StoreModule.forRoot({}),
    StoreModule.forFeature(SENSOR_FEATURE_KEY, sensorTypeReducer),
    EffectsModule.forRoot([]), // For root effects
    EffectsModule.forFeature([SensorEffects]),
    // configuration for the Redux DevTools Extension
    environment.production ? [] : StoreDevtoolsModule.instrument({ maxAge: 25 }),
  ],
})
export class RootStoreModule {}
